module.exports = __webpack_public_path__ + "./img/src/img/cases/primeirafolha/case_primeirafolha02.jpg";